export default __webpack_public_path__ + "static/media/Group 2ANTES-DEPOIIS.0af12198.png";